// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2mhKv"};